interface SpacerProps {
  width?: number;
  height?: number;
}

export default function Spacer({ width = 0, height = 0 }: SpacerProps) {
  return <div style={{ width: `${width}px`, height: `${height}px` }} />
}